import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-deposit',
  templateUrl: './deposit.component.html',
  styleUrls: ['./deposit.component.scss']
})
export class DepositComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
